export const VOLUME_DISCOUNT_CONSTRAINTS = {
    name: { label: 'Name', maxLength: 100 },
    tiers: { label: 'Tiers', min: 1, max: 10 },
    minCases: { label: 'Minimum cases' },
    value: { label: 'Markdown', maxPercent: 100, maxFlat: 1_000_000 },
    excludedProductIds: { label: 'Excluded products', max: 500 },
};
//# sourceMappingURL=constraints.js.map